var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "hiddenDom",
    staticClass: "hidden-dom",
    class: {
      'first-hidden-dom': _vm.index === 0
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };